'use strict';

var unified = require('unified');
var parse = require('remark-parse');
var stringify = require('remark-stringify');

module.exports = unified().use(parse).use(stringify).freeze();



//////////////////
// WEBPACK FOOTER
// ./~/remark/index.js
// module id = 208
// module chunks = 95715928098905 168707334958949